// Module
var code = " <svg width=\"10px\" height=\"10px\" viewBox=\"0 0 12 12\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <rect id=\"Rectangle\" x=\"0\" y=\"0\" width=\"11.8095238\" height=\"11.8095238\" rx=\"0.6\"></rect> </svg> ";
// Exports
module.exports = code;